import React, { useState, useEffect } from "react";
import Layout from "../Layout";
import { Button, TextField } from "@mui/material";
import axios from "axios";
import { useParams } from "react-router-dom";
import MaterialTable from "@material-table/core";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

const OperationsHistory = () => {
  const { worker } = useParams();
  const [operationsHistoryList, setOperationsHistoryList] = useState([]);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [startDateTime, setStartDateTime] = useState(null);
  const [endDateTime, setEndDateTime] = useState(null);

  const GetData = async () => {
    try {
      setLoading(true);
      const getOperationsHistory = await axios.get(
        "http://83.144.125.123:5222/Document/GetOperationsHistory",
        {
          params: {
            worker: worker,
            operationStart: startDateTime,
            operationEnd: endDateTime,
          },
        }
      );

      setOperationsHistoryList(getOperationsHistory.data);

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
      alert(
        "Wystapił nieoczekiwany błąd podczas wywołania funkcji /Operations/GetData. Skontaktuj się z administratorem systemu. Komuniakt zwrotny: "
      );
    }
  };

  const goBack = () => {
    history.push("/" + worker);
    history.go();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    GetData();
  }, []);

  useEffect(() => {
    setStartDateTime();
    const handleBrowserBack = () => {
      history.push("/" + worker);
      history.go();
    };

    // Add the event listener for the browser's back button
    window.addEventListener("popstate", handleBrowserBack);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("popstate", handleBrowserBack);
    };
  }, [history]);

  const options = {
    paging: true,
    filtering: true,
    pageSize: 20,
    pageSizeOptions: [20, 50, 100, 9999],
  };

  return (
    <Layout>
      <div className="positions-container">
        {loading && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
          </div>
        )}
        <Button
          variant="contained"
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={goBack}
        >
          Powrót
        </Button>
        <div className="section">
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className="firstcolumn">
                  <b>Pracownik</b>
                </TableCell>
                <TableCell>{worker}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
        <div className="twoDateTimePicker">
          <TextField
            label="Zakończenie - od"
            type="date"
            defaultValue={startDateTime}
            value={startDateTime}
            onChange={(e) => setStartDateTime(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </div>
        <div className="dateTimePicker">
          <TextField
            label="Zakończenie - do"
            type="date"
            defaultValue={endDateTime}
            value={endDateTime}
            onChange={(e) => setEndDateTime(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </div>
        <div className="largeButtonSection">
          <Button
            variant="contained"
            color="primary"
            className="largeButtonJob"
            onClick={GetData}
          >
            POKAŻ
          </Button>
        </div>
        <div className="datatable">
          <MaterialTable
            localization={{
              body: {
                emptyDataSourceMessage: "Brak danych",
                addTooltip: "Dodaj",
                deleteTooltip: "Usuń",
                editTooltip: "Edytuj",
                filterRow: {
                  filterTooltip: "Filtrowanie",
                },
                editRow: {
                  deleteText: "Czy na pewno usunąć ten wiersz?",
                  cancelTooltip: "Anuluj",
                  saveTooltip: "Zapisz",
                },
              },
              grouping: {
                placeholder: "Przeciągnij kolumny ...",
                groupedBy: "Pogrupowane według:",
              },
              header: {
                actions: "Działania",
              },
              pagination: {
                labelDisplayedRows: "{from}-{to} z {count}",
                labelRows: "",
                labelRowsPerPage: "Wierszy na stronę:",
                firstAriaLabel: "Pierwsza strona",
                firstTooltip: "Pierwsza strona",
                previousAriaLabel: "Poprzednia strona",
                previousTooltip: "Poprzednia strona",
                nextAriaLabel: "Następna strona",
                nextTooltip: "Następna strona",
                lastAriaLabel: "Ostatnia strona",
                lastTooltip: "Ostatnia strona",
              },
              toolbar: {
                addRemoveColumns: "Dodaj lub usuń kolumny",
                nRowsSelected: "{0} wybranych wierszy",
                showColumnsTitle: "Pokaż kolumny",
                showColumnsAriaLabel: "Pokaż kolumny",
                exportTitle: "Exportuj",
                exportAriaLabel: "Exportuj",
                exportName: "Export do CSV",
                searchTooltip: "Szukaj",
                searchPlaceholder: "Szukaj",
              },
            }}
            columns={[
              { title: "Dokument", field: "documentNumber" },
              { title: "Pozycja", field: "originNo" },
              { title: "Gniazdo", field: "warehouse" },
              { title: "Kod operacji", field: "code" },
              { title: "Nazwa operacji", field: "name" },
              {
                title: "Zrealizowano",
                field: "realized",
                cellStyle: (rowData) => ({
                  fontWeight: "bold",
                }),
              },
              {
                title: "Rozpoczęcie",
                field: "operationStart",
                render: (rowData) => {
                  if (
                    rowData.operationStart.toString() !== "0001-01-01T00:00:00"
                  ) {
                    return new Date(rowData.operationStart).toLocaleString(
                      "pl-PL",
                      {
                        timeZone: "Europe/Warsaw",
                        hour12: false,
                      }
                    );
                  } else {
                    return "-";
                  }
                },
              },
              {
                title: "Zakończenie",
                field: "operationEnd",
                render: (rowData) => {
                  if (
                    rowData.operationEnd.toString() !== "0001-01-01T00:00:00"
                  ) {
                    return new Date(rowData.operationEnd).toLocaleString(
                      "pl-PL",
                      {
                        timeZone: "Europe/Warsaw",
                        hour12: false,
                      }
                    );
                  } else {
                    return "-";
                  }
                },
              },
              { title: "Pracownik", field: "worker" },
            ]}
            options={options}
            data={operationsHistoryList}
            title="Historia wykonanych operacji"
          />
        </div>
      </div>
      <br />
      <small className="rightsText">
        © 2023 — Aplikacja{" "}
        <a
          href="https://www.center.pl/"
          target={"_blank"}
          className="clearLink"
        >
          Computer Center
        </a>
        . Wszelkie prawa zastrzeżone
      </small>
    </Layout>
  );
};

export default OperationsHistory;
